/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Smartlab_Settings_Save_MachineInputs */

const vi_smartlab_settings_save_machine = /** @type {(inputs: Smartlab_Settings_Save_MachineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lưu máy vò chè`)
};

/**

* @param {Smartlab_Settings_Save_MachineInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const smartlab_settings_save_machine = /** @type {((inputs?: Smartlab_Settings_Save_MachineInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Smartlab_Settings_Save_MachineInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_smartlab_settings_save_machine(inputs)
});